import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4">
            <i className="ri-chat-smile-3-line" />
            用户评价
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            听听用户怎么说
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-1 flex flex-col gap-3">
            {testimonials.map((item, index) => (
              <button
                key={item.id}
                onClick={() => setActive(index)}
                className={`flex items-center gap-4 p-4 rounded-xl text-left transition-all duration-300 ${
                  index === active
                    ? 'bg-foreground-950 text-white shadow-lg'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover shrink-0"
                  loading="lazy"
                />
                <div>
                  <p className={`font-semibold text-sm ${index === active ? 'text-white' : 'text-foreground-900'}`}>
                    {item.name}
                  </p>
                  <p className={`text-xs ${index === active ? 'text-foreground-400' : 'text-foreground-500'}`}>
                    {item.role}
                  </p>
                </div>
              </button>
            ))}
          </div>

          <div className="lg:col-span-2 bg-foreground-950 rounded-2xl p-6 md:p-10 flex flex-col justify-center">
            <div className="mb-6">
              <i className="ri-double-quotes-l text-4xl md:text-5xl text-primary-500/30" />
            </div>
            <blockquote className="text-white text-lg md:text-xl leading-relaxed mb-8">
              {t.content}
            </blockquote>
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`ri-star-fill text-sm ${
                    i < t.rating ? 'text-amber-400' : 'text-foreground-700'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}